import { Box } from '@mui/material';
import { pdvScale } from './pdvScale';

// Decoração do fundo do tema Grafite — mesma filosofia da LoginTechDecoration/
// PDVBasicoDecoration/PDVOceanDecoration (100% CSS/MUI, sem imagem): linhas
// diagonais discretas nos cantos, grade de pontos esmaecendo nas bordas
// (mask) e duas formas rotacionadas com anéis de box-shadow, uma pra cada
// lado (igual o tema Básico). O gradiente de base (dois brilhos radiais
// azulados + diagonal escuro quase-preto→azul-marinho) fica em
// PDVThemes.ts (colors.backgroundImage do tema 'grafite') — aqui só as
// camadas que dependem de mask-image/box-shadow, que um background-image
// comum não consegue expressar. Todos os tamanhos usam pdvScale (mesma
// escala global do PDV, ver pdvScale.ts) em vez de clamp()/vw própria, pra
// não voltar ao problema de cada elemento escalando numa curva diferente.
export const PDVGrafiteDecoration: React.FC = () => (
  <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    {/* Linhas diagonais bem sutis nos cantos superior-esquerdo/inferior-direito. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: `
          linear-gradient(135deg, transparent 0 7%, rgba(105, 139, 191, 0.035) 7% 12%, transparent 12% 100%),
          linear-gradient(315deg, transparent 0 7%, rgba(105, 139, 191, 0.045) 7% 13%, transparent 13% 100%)
        `,
      }}
    />

    {/* Grade de pontos azulada — esmaece nas bordas (mask), diagonal como as linhas acima. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.45,
        backgroundImage: 'radial-gradient(circle, rgba(101, 137, 194, 0.25) 1.5px, transparent 1.8px)',
        backgroundSize: '20px 20px',
        maskImage: 'linear-gradient(135deg, #000 0%, transparent 21%, transparent 79%, #000 100%)',
        WebkitMaskImage: 'linear-gradient(135deg, #000 0%, transparent 21%, transparent 79%, #000 100%)',
      }}
    />

    {/* Forma esquerda — quadrado arredondado a 45°, sangrando pra fora da
        borda esquerda, com dois anéis concêntricos via box-shadow. */}
    <Box
      sx={{
        position: 'absolute',
        left: pdvScale(-330),
        top: '18%',
        width: pdvScale(450),
        height: pdvScale(450),
        border: '2px solid rgba(105, 139, 191, 0.10)',
        borderRadius: pdvScale(80),
        transform: 'rotate(45deg)',
        boxShadow: `
          ${pdvScale(55)} ${pdvScale(55)} 0 rgba(80, 113, 166, 0.025),
          ${pdvScale(110)} ${pdvScale(110)} 0 rgba(80, 113, 166, 0.018)
        `,
      }}
    />

    {/* Forma direita — espelhada, sangrando pra fora da borda direita. */}
    <Box
      sx={{
        position: 'absolute',
        right: pdvScale(-330),
        bottom: '-5%',
        width: pdvScale(450),
        height: pdvScale(450),
        border: '2px solid rgba(105, 139, 191, 0.10)',
        borderRadius: pdvScale(80),
        transform: 'rotate(45deg)',
        boxShadow: `
          ${pdvScale(-55)} ${pdvScale(-55)} 0 rgba(80, 113, 166, 0.025),
          ${pdvScale(-110)} ${pdvScale(-110)} 0 rgba(80, 113, 166, 0.018)
        `,
      }}
    />
  </Box>
);
